// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__8xd-f","pulsePolygon":"Loader_pulsePolygon__mJKIM","inner":"Loader_inner__8h2FG","text":"Loader_text__9VOSE"};